'use client';
import { Post } from '@telesoft/types/payload-types';
import React, { ReactElement, useState } from 'react';
import { FaEnvelope, FaLink, FaLinkedin, FaTwitter } from 'react-icons/fa';
import toast from 'react-hot-toast';
import {
  EmailShareButton,
  LinkedinShareButton,
  TwitterShareButton,
} from 'react-share';

interface Props {
  article: Post;
}

function ShareArticleButtons({ article }: Props): ReactElement {
  const [copied, setCopied] = useState('Copy link');
  const [url, setUrl] = useState('');

  React.useEffect(() => {
    if (typeof window !== 'undefined') {
      setUrl(window.location.href);
    }
  });

  return (
    <div className="col-span-4 border-t border-heading flex">
      <div className="flex flex-col justify-start items-start w-full">
        <h5 className="text-xs mb-1 text-body pt-4">SHARE ARTICLE</h5>

        <div className="flex justify-start items-center text-heading">
          <EmailShareButton
            url={url}
            subject={`Telesoft Nucleus: ${article.title}`}
            body={`Here's an article from Telesoft Nucleus I thought I'd share with you:`}
            separator={' '}
            className="w-8 h-8"
          >
            <FaEnvelope />
          </EmailShareButton>

          <TwitterShareButton
            url={url}
            title={article.title}
            via="telesoft_tech"
            className="w-8 h-8"
          >
            <FaTwitter />
          </TwitterShareButton>

          <LinkedinShareButton
            title={article.title}
            summary={article.summary}
            url={url}
            className="w-8 h-8"
          >
            <FaLinkedin />
          </LinkedinShareButton>

          <button
            type="button"
            onClick={() => {
              const currentUrl = url;
              navigator.clipboard.writeText(currentUrl);
              setCopied('Link copied!');
              toast.success('Link copied', { id: 'LINK' });
            }}
            className="group h-8 mr-4 flex justify-center items-center"
          >
            <FaLink className="mr-2" />
            <span className="text-xs text-heading border-b border-gray-300 group-hover:border-telesoft">
              {copied}
            </span>
          </button>
        </div>
      </div>
    </div>
  );
}

export default ShareArticleButtons;
